<script setup lang="ts">
import type { IFeatures } from '@/models'
import FeatureList from './children/FeatureSecondaryList.component.vue'
const { translate } = useLocalization()
// retrieve page data passed down from layouts:
const features: IFeatures = <any>useAttrs().features
</script>

<template>
  <div id="featurelist" class="bg-secondary content-secondary bg-opacity-90 opacity-100 py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-2xl mb-16 lg:mx-0">
        <h2 class="text-base font-semibold leading-7">
          {{ features?.title }}
        </h2>
        <p v-if="features?.subtitle" class="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">
          {{ features?.subtitle }}
        </p>
        <p class="mt-6 text-lg leading-8">
          {{ features?.summary }}
        </p>
      </div>

      <div class="mx-auto max-w-2xl lg:max-w-none">
        <FeatureList :items="features?.items" />
      </div>

      <div class="mt-16 mx-auto max-w-2xl lg:max-w-none">
        <a
          href="#pricing"
          class="content-secondary opacity-80 hover:opacity-100 text-sm font-semibold leading-6"
        >
          {{ translate('navigation.pricing') }} <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  </div>
</template>
